import { memo } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
} from "@xyflow/react";
import type { EditorEdge } from "../../core/editor-types";

const edgeColors: Record<string, string> = {
  slate: "#7a7f87",
  blue: "#5683df",
  green: "#4d9b70",
  rose: "#d67178",
  amber: "#c99642",
  violet: "#8a70c9",
};

export const CanvasEdge = memo(function CanvasEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  selected,
  data,
}: EdgeProps<EditorEdge>) {
  const [path, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    curvature: 0.32,
  });
  const colorValue = String(data?.color ?? "slate");
  const color = edgeColors[colorValue] ?? (/^(#|rgb|hsl|var\()/.test(colorValue) ? colorValue : edgeColors.slate);
  const label = typeof data?.label === "string" ? data.label : "";

  return (
    <>
      <BaseEdge
        id={id}
        path={path}
        markerEnd={markerEnd}
        interactionWidth={16}
        style={{ stroke: color, strokeWidth: selected ? 2.5 : 1.8 }}
      />
      {label ? (
        <EdgeLabelRenderer>
          <span
            className="nodrag nopan edge-label"
            style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)` }}
          >
            {label}
          </span>
        </EdgeLabelRenderer>
      ) : null}
    </>
  );
});
